import { useSelector } from '@xstate/store-react';
import { store } from '../store';

export const useApplianceFormData = () => useSelector(store, (state) => state.context.form);
